import { apiInstance } from "@src/config/api";
import { PUBLIC_V1 } from "@src/constant/common";
import { objectToQueryParams } from "@src/helper/objectToQueryParams";

const api = apiInstance()

export const getOnlineProfile = async (id) => {
  return api.get(`/${PUBLIC_V1}/online-profile/user/${id}`)
}

export const getListPropertyOnlineProfile = async (id, params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api.get(`/${PUBLIC_V1}/online-profile/properties/${id}?${newParams}`)
}
